import { Directive, ViewContainerRef, TemplateRef, Input } from '@angular/core';

// https://stackoverflow.com/questions/38582293/how-to-declare-a-variable-in-a-template-in-angular

/// USAGE: <p *libVar="my.expr as val">{{ val }}</p>
@Directive({
    selector: '[libVar]',
    standalone: false
})
export class VarDirective {
    @Input()
    set libVar(context: any) {
        this.context.$implicit = this.context.libVar = context;
        this.updateView();
    }

    context: any = {};

    constructor(private vcRef: ViewContainerRef, private templateRef: TemplateRef<any>) { }

    updateView() {
        this.vcRef.clear();
        this.vcRef.createEmbeddedView(this.templateRef, this.context);
    }
}
